import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import RosterHero from "./components/RosterHero";
import WrestlerGrid from "./components/WrestlerGrid";

export default function RosterPage() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <RosterHero />
      <WrestlerGrid />
      <Footer />
    </div>
  );
}
